@if (unknownAddress) {
  <mwe-inline-notification
    type="danger"
    titleKey="address-input.unknownAddress.title"
    messageKey="address-input.unknownAddress.description"
  />
}

<div class="sr-only" aria-live="assertive">
  @if (suggestions.length === 1) {
    {{ 'address-input.result.singleResult' | translate }}
  }
  @if (suggestions.length > 1) {
    {{ suggestions.length }} {{ 'address-input.result.multipleResults' | translate }}
  }
</div>
<form>
  @if (hasSelectionEntries) {
    <div>
      <label translate="address-input.selection"></label>
      <div class="row gx-2">
        @for (pill of selectionEntries; track pill; let last = $last) {
          <div class="col-auto">
            <mwe-pill-badge
              [text]="pill.text"
              [state]="pill.state"
              [isLast]="last"
              [closable]="true"
              type="light"
              (unselect)="unselect($event, pill.state)"
              #pills
            />
          </div>
        }
      </div>
    </div>
  }

  @if (selectionState !== 'complete') {
    <div class="mb-3 dropdown" (keyup)="keyboardNavigation($event)">
      <div class="row flex-nowrap">
        <div class="col">
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              [ngClass]="{ 'is-invalid': showErrorMsg }"
              id="mwe-address-input-field"
              name="address"
              (keydown)="limitChars($event)"
              (keyup)="onInput($event)"
              (focus)="_hideDropdown = false"
              (blur)="_hideDropdown = true"
              [formControl]="input"
              required
              autocomplete="off"
              [placeholder]="inputPlaceholder"
              #inputElement
              role="combobox"
              aria-autocomplete="both"
              aria-owns="address-input-dropdown"
              [attr.aria-activedescendant]="selectedOption?.id"
              [attr.aria-description]="inputDescription || null"
              [attr.aria-describedby]="showErrorMsg ? 'mwe-address-input-field-desc' : null"
            />
            <label for="mwe-address-input-field"
              >{{ inputLabel }}
              @if (isAlreadyValidAddress) {
                <span class="has-text-gray-500" translate="address-input.inputLabel.optional"></span>
              }
            </label>
            @if (isSearching) {
              <div class="form-floating-icon">
                <span class="loading-spinner d-flex" style="--bs-loading-spinner-color: #949494; width: 1.5rem; height: 1.5rem"></span>
              </div>
            }
          </div>
          @if (showErrorMsg) {
            <div class="font-size-12 text-danger mt-1" role="alert" data-test="address-inpout-error-msg" id="mwe-address-input-field-desc">
              <i class="fa fa-exclamation-circle mr-1" aria-hidden="true"></i>
              <span translate="address-input.error"></span>
            </div>
          }
        </div>
      </div>
      @if (suggestions.length > 0) {
        <div
          class="dropdown-menu w-100 d-block overflow-auto"
          id="address-input-dropdown"
          #dropdown
          style="max-height: 230px"
          role="listbox"
          [ngClass]="{ 'sr-only-focusable': _hideDropdown }"
        >
          <h6 class="dropdown-header" translate="address-input.searchResults"></h6>
          @for (suggestion of suggestions; track suggestion; let idx = $index) {
            <div
              id="{{ 'mwe-address-input-field-result-' + idx }}"
              class="dropdown-item"
              (mousedown)="selectSuggestion(suggestion, $event)"
              [attr.data-suggestion-index]="idx"
              role="option"
            >
              <i class="far fa-map-marker-alt mr-2"></i>
              {{ getSelectionText(suggestion.docs[0]) }}
            </div>
          }
        </div>
      }
    </div>
  }

  @if (hasNoResults) {
    <div class="mb-3">
      <mwe-infobox type="info" titleKey="address-input.hasNoResults.title" messageKey="address-input.hasNoResults.description" />
    </div>
    @if (noResultsButtonText) {
      <div class="row justify-content-center">
        <mwe-button (clicked)="noResultsButtonClicked.emit()" [labelKey]="noResultsButtonText" />
      </div>
    }
  }
</form>
